import React, { useEffect, useState } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import ContainerComponent from './ContainerComponent';
import { SET_VALUE } from '../formReducer';

interface Props {
  value: any;
  formId: string;
  formName: string;
  formDispatch: any;
  item: {
    label: string;
    name: string;
    placeholder: string;
    subtype: string;
    required: boolean;
    values: {
      label: string;
      selected: boolean;
      value: string;
    }[];
    description: string;
  };
  readOnly: boolean;
}

const decodeHtmlEntities = (str: string) => {
  if (!str) return str;
  const txt = typeof window !== 'undefined' ? document.createElement('textarea') : null;
  if (!txt) return str;
  txt.innerHTML = str;
  return txt.value;
};

const RadioFieldComponent: React.FC<Props> = ({
  value,
  formDispatch,
  formId,
  formName,
  item: { label, values, name: fieldId, required, description },
  readOnly,
}) => {
  const convertValues = (
    values: {
      label: string;
      selected: boolean;
      value: string;
    }[],
  ) => {
    const out: { [key: string]: boolean } = {};
    values.forEach((item) => (out[item.value] = item.selected));
    return out;
  };

  const getTrueValue = (values: any) => {
    const keys = Object.keys(values || {});
    let outKey: string | null = null;
    keys.forEach((key) => {
      if (values[key]) outKey = key;
    });
    return outKey;
  };

  const [convertedValues, setConvertedValues] = useState<any>(value ? value : convertValues(values || []));

  useEffect(() => {
    formDispatch({
      type: SET_VALUE,
      payload: { value: convertedValues, fieldId, formId },
    });
    formDispatch({
      type: SET_VALUE,
      payload: { value: convertedValues, fieldId, formId: formName },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [convertedValues]);

  const handleChange = ({ target: { value } }: any) => {
    const keys = Object.keys(convertedValues || {});
    const newConvertedValues: any = { ...convertedValues };
    keys.forEach((key) => {
      newConvertedValues[key] = key === value;
    });
    setConvertedValues(newConvertedValues);
  };

  return (
    <ContainerComponent label={label} required={required} description={description}>
      <RadioGroup value={getTrueValue(convertedValues)} onChange={handleChange}>
        {(values || []).map(({ label, value }) => (
          <FormControlLabel
            key={label}
            value={value}
            control={<Radio color={'primary'} />}
            label={decodeHtmlEntities(label)}
            style={{ fontSize: 14 }}
            disabled={readOnly}
          />
        ))}
      </RadioGroup>
    </ContainerComponent>
  );
};

export default RadioFieldComponent;
